import { OAuthCredentialsService } from '~src/connectivity/services/OAuthCredentialsService';

// Curated allowlist of connector classes that support Workload Identity
// Federation. Two surfaces consume this list and must stay in sync:
// the CREATE form in WifConnectorsSection (admins can only create WIF
// connectors of these classes), and the JwtPreviewModal dropdown (the
// preview must not surface a connector whose class is outside this list,
// even if a future server release or manual DB row introduces one).
//
// Labels are not hardcoded here — they come from the server's connector
// display-name map via OAuthCredentialsService.getDisplayNameFromType.
export const WIF_CONNECTOR_CLASSES: ReadonlyArray<string> = ['googlebigquery', 'snowflake'];

// Localized connector display name from the server (e.g. 'googlebigquery' ->
// 'Google BigQuery (JDBC)'). Co-located with the allowlist so both consumers
// of the WIF connector list use the same label helper.
export function connectorClassLabel(connectorClass: string): string {
  return OAuthCredentialsService.getDisplayNameFromType(connectorClass);
}
